 $('.all-evslider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
   prevArrow: '<button class="prevarrow"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6886 9.20963L1.53735 5.0276L5.71937 0.87635" stroke="#1EB99B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
   nextArrow: '<button class="nextarrow"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.38562 9.20963L5.53687 5.0276L1.35485 0.87635" stroke="#1EB99B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
});
 $('.all-performance').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
   dots: true,
   prevArrow: '<button class="prevarrow"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6886 9.20963L1.53735 5.0276L5.71937 0.87635" stroke="#1EB99B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
   nextArrow: '<button class="nextarrow"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.38562 9.20963L5.53687 5.0276L1.35485 0.87635" stroke="#1EB99B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
});

 $('.all-carousel').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
   dots: true,
    autoplay: true,
   prevArrow: '<button class="prevarrow"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.6886 9.20963L1.53735 5.0276L5.71937 0.87635" stroke="#1EB99B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
   nextArrow: '<button class="nextarrow"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.38562 9.20963L5.53687 5.0276L1.35485 0.87635" stroke="#1EB99B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


document.querySelectorAll('.playButton').forEach(function(button) {
    button.addEventListener('click', function() {
        // Get the video player immediately before this button in the DOM
        var video = button.previousElementSibling; 
        if (video.tagName === 'VIDEO') {
            video.play(); // Play the video
            button.style.display = 'none'; // Hide the button
          button.parentElement.classList.add('active');
        }
    });
});